export default "__VITE_ASSET__BoZJoqEG__"